import type { Translate, TranslationKey } from '~/shared/internationalization/translation';

const ROLE_LABEL_KEYS = {
    user: 'pages.company-settings.users-and-roles.roles.user',
    viewer: 'pages.company-settings.users-and-roles.roles.viewer',
    reviewer: 'pages.company-settings.users-and-roles.roles.reviewer',
    job_architect: 'pages.company-settings.users-and-roles.roles.job_architect',
    hiring_manager: 'pages.company-settings.users-and-roles.roles.hiring_manager',
    recruiter: 'pages.company-settings.users-and-roles.roles.recruiter',
    talent_developer: 'pages.company-settings.users-and-roles.roles.talent_developer',
    hr_talent: 'pages.company-settings.users-and-roles.roles.hr_talent',
    transformation_lead: 'pages.company-settings.users-and-roles.roles.transformation_lead',
} as const satisfies Readonly<Record<string, TranslationKey>>;

type KnownRole = keyof typeof ROLE_LABEL_KEYS;

const KNOWN_ROLES = Object.keys(ROLE_LABEL_KEYS);

const isKnownRole = (role: string): role is KnownRole => Object.hasOwn(ROLE_LABEL_KEYS, role);

export const sortRoles = (roles: readonly string[]): readonly string[] => [
    ...KNOWN_ROLES.filter((role) => roles.includes(role)),
    ...roles.filter((role) => !isKnownRole(role)),
];

export const selectedRoles = (roles: readonly string[], manageable: readonly string[]): readonly string[] =>
    manageable.filter((role) => roles.includes(role));

export const nextRoles = (
    current: readonly string[],
    selected: readonly string[],
    manageable: readonly string[],
): readonly string[] => [...new Set([...sortRoles(selected), ...current.filter((role) => !manageable.includes(role))])];

export const roleLabel = (translate: Translate, role: string): string => {
    if (isKnownRole(role)) {
        return translate(ROLE_LABEL_KEYS[role]);
    }

    return role
        .split('_')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
};
